import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import { HeaderShim } from '../../fuselage/global/header/header'
import { ArrowButton } from "../../fuselage/components/arrow-button/arrow-button"
import { StickySidebar } from "../../fuselage/layout/sticky-sidebar/sticky-sidebar"
import { ContentCard } from "../../fuselage/components/content-card/content-card"

export default function ContentLibrary ({ articles, categories }) {

    // console.log('articles"', articles)

    const handleCategoryMenu = () => {        
        if ( categories.length ) {
            return (
                categories.map( category => {
                    return (
                        <section key={category.id} id={category.slug} className="mb-xxs">
                            <a className="uLink fs-6 fw-600 c-primary" href={`/content-library/category/${category.slug}`}>{category.title}</a>
                        </section>
                    )
                })
            )
        }
    }

    const handleCategorisedArticles = () => {
        return (
            categories.map( category => {

                let entries = []
                
                articles.map( article => {
                    article.contentTypes.find( cat => {
                        if (cat.id === category.id) {
                            entries.push(article)
                        }
                    } )
                })

                if ( entries.length ) {

                    return (
                        <section key={category.id} id={category.slug} className="mt-md">
                            <p className="fs-2 fw-600 caps c-secondary">{category.title}</p>
                            
                            <div className="columns-3 gap-sm mt-sm">
                                {
                                    entries.slice(0, 3).map( entry => (
                                        <ContentCard
                                            key={entry.id}
                                            url={`/content-library/${entry.slug}`}
                                            heroUrl={entry.contentLibraryHero && entry.contentLibraryHero[0] ? entry.contentLibraryHero[0].url : null}
                                            heading={entry.title}
                                            excerpt={entry.excerpt}
                                            contentTypes={entry.contentTypes}
                                            postDate={entry.postDate}
                                        />
                                    ))
                                }
                            </div>
    
                            <p className="mt-sm"><ArrowButton href={`/content-library/category/${category.slug}`}>See all in {category.title}</ArrowButton></p>
                        </section>
                    )
                }
            })
        )
    }

    return (
        <> 
            <section className="block bg-default pt-0">
                <StickySidebar size='small'>

                    <aside>
                        <HeaderShim />
                        <p className="fs-6 fw-600 c-secondary mb-sm">Filter</p>
                        { handleCategoryMenu() }
                        
                        <div className="mt-md formatted">
                            <p className="fs-4 fw-600 lh-2 c-secondary">Get updates in your&nbsp;inbox</p>
                            <p>We share the latest updates to our subscribers every two weeks. Sign up today and stay updated!</p>
                            <p><ArrowButton href="/stay-updated" theme='default'>Sign up</ArrowButton></p>
                        </div>
                    </aside>

                    <main>
                        <HeaderShim />
                        <p className="fs-0 fw-600 c-primary">Content library</p>
                        { handleCategorisedArticles() }
                    </main>

                </StickySidebar>
            </section>
        </>
    )
    
}

export async function getStaticProps() {
    const { data } = await craftApolloClient().query({
        query: gql`
            query Articles {
                entries(site: "${process.env.SITE_HANDLE}", section: "contentLibrary") {
                    ... on contentLibrary_article_Entry {
                        id
                        slug
                        title
                        postDate
                        excerpt
                        contentLibraryHero {
                            id
                            url
                            width
                            height
                        }
                        contentTypes {
                            ... on contentLibrary_Category {
                                id
                                title
                            }
                        }
                    }
                }
                categories (
                    group: "contentLibrary"
                    id: [121314, 7701, 7703, 7704, 7700]
                    fixedOrder: true
                ) {
                    id
                    title
                    slug
                }
            }
          
        `
        })

        return {
        props: {
            articles: data.entries,
            categories: data.categories
        },
    }
}